import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface RefetchQuotesInput {
    orderId: string;
}

const refetchQuotes = async (data: RefetchQuotesInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/quotes/refetch`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useRefetchQuotes = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: RefetchQuotesInput) => refetchQuotes(data, sessionContext?.sessionId ?? null),
        onError: (error) => {
            console.error('Failed to refetch quotes:', error);
        }
    });
};
